import { useQuery } from '@tanstack/react-query';
import { useAuth } from '~/app/auth/context/AuthContext';
import {
  SiteService,
  type SiteOperationsMapResponse,
} from '~/app/services/site/site.service';

export function useSupervisorOperationsMap() {
  const { user } = useAuth();
  const organizationId = user?.organizationId ?? '';

  const query = useQuery({
    queryKey: ['sites', 'operations-map', organizationId],
    queryFn: () =>
      SiteService.findOperationsMapByOrganizationId(organizationId),
    enabled: !!organizationId,
  });

  return {
    data: (query.data ?? null) as SiteOperationsMapResponse | null,
    error: (query.error ?? null) as Error | null,
    isFetching: query.isFetching,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
